import { createReducer, on } from "@ngrx/store";
import { LayoutState } from "../../core/models/layout";
import { initialState } from "./layout.state";
import {clearMessageToast, setDarkMode, setMessageToast, setTitle, setToggleSidenav, startLoading, stopLoading} from "./layout.action";

export const _layoutReducer = createReducer(
    initialState,
    on(startLoading, (state) => ({ ...state, loading: true })),
    on(stopLoading, (state) => ({ ...state, loading: false })),
    on(setMessageToast, (state, action) => ({ ...state, messageToast: action.message })),
    on(clearMessageToast, (state) => ({ ...state, messageToast: '' })),
    on(setDarkMode, (state, action) => ({...state , darkMode: action.darkMode}    )),
    on(setTitle, (state, action) => ({ ...state, title: action.title })),

    on(setToggleSidenav, (state, action) => ({ ...state, toggleSidenav: action.toggleSidenav })),


);


export function layoutReducer(state: LayoutState | undefined, action: any) {
    return _layoutReducer(state, action);
}
